import { useContext } from "react";

import log from "loglevel";

import { ApplicationInsightsContext } from "@/shared/contexts";
import { EventTypes } from "@/shared/hooks";

type EventService<Types = EventTypes> = {
    trackEvent: (name: Types, properties?: any) => void;
};

export const useEvents = <Types = EventTypes,>(prefix: string): EventService<Types> => {
    const { ApplicationInsights } = useContext(ApplicationInsightsContext);

    const getEvent = (name: Types, properties = null) => {
        return { name: `${prefix}.${name}`, properties };
    };
    const trackEvent = (name: Types, properties = null) => {
        const event = getEvent(name, properties);
        log.info("track event", event);
        ApplicationInsights?.trackEvent(event);
    };

    return {
        trackEvent,
    };
};
